import React, {useState,useEffect} from 'react';
import '../../../App.css';
// import '../../../style.css';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Banner from './Banner';
import Topic from './Topic';
import List from './List';


const Index = () => {
  return (
    <div className="app-container">
      <Navbar/>     
      <Banner/>
      <Topic/>
      <List/>
      <Footer/>
    </div>
  );
};

export default Index;